var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTronscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5cm",
    height: "1.3cm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43.2 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c23631;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0,
    width: 146,
    height: 35.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7L17.4,0l17.4,7-17.4,7L0,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,7v21.6l-1.5-.6V7h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.2,13v21.7l-.7.3-.8-.3V13h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.5,34.2l-1.3.5-.7.3-.8-.3-1.2-.5L1.5,28.6l-1.5-.6v-1.6l1.5.6,15.2,6.1.8.3.7.3,1.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7v1.6l18.2,7.3v-1.6L0,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.1,3.7l-25.8,10.4.6,1.4,25.2-10.1v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.1,10.2l-25.8,10.4.6,1.4,25.2-10.1v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.1,16.7l-25.8,10.4.6,1.4,25.2-10.1v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.1,23.2v1.6l-23.6,9.5-1.3.5-.7.3-.8-.3-1.2-.5,1.2-.5.8-.3.7-.3,24.9-10Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronscan);
export default __webpack_public_path__ + "static/media/tronscan.9edec7ad0c87a495a0f50e325f9ffa7b.svg";
export { ForwardRef as ReactComponent };